import { render, staticRenderFns } from "./tasks-count-renderer.vue?vue&type=template&id=aae95784&lang=html"
import script from "./tasks-count-renderer.vue?vue&type=script&lang=js"
export * from "./tasks-count-renderer.vue?vue&type=script&lang=js"
import style0 from "./tasks-count-renderer.vue?vue&type=style&index=0&id=aae95784&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports